import React, { createContext, useMemo, useState } from "react";
import { Route } from "react-router-dom";
import { ListadoScreenVentas } from "./ListadoScreenVentas";
import { LineasScorecardScreen } from "./LineasScorecard/LineasScorecardScreen";
import { ListadoVendedores } from "./VendedoresScorecard/ListadoVendedores";
import { ScorecardVendedor } from "./VendedoresScorecard/ScorecardVendedor";
import { ListadoScorecardReal } from "./VendedoresScorecardReal/ListadoScorecardReal";
import { ScorecardRealVendedor } from "./VendedoresScorecardReal/ScorecardRealVendedor";
import { FiltroScorecard } from "./FiltradoScorecardObjetivo/FiltroScorecard";
import { ScorecardSucursal } from "./FiltradoScorecardObjetivo/ScorecardSucursal";
import { ScorecardObjetivoVendedor } from "./FiltradoScorecardObjetivo/ScorecardObjetivoVendedor";
import { SolicitudCreditoFacturada } from "./SolicitudesCreditoFacturadas/SolicitudCreditoFacturada";
import { TiemposOperacionScreen } from "./TiemposOperacion/TiemposOperacion";
import { DashScorecardVendedorScreen } from "../Dashboard/Vendedor/DashScorecardVendedorScreen";
import { DashScorecardGerenteScreen } from "../Dashboard/Vendedor/DashScorecardGerenteScreen";

import { CumplimientoDocumentacionCondicionadaScreen } from "./CumplimientosCompromisoCredito/CumplimientoDocumentacionCondicionadaScreen";

import { FacturacionMaquinariaScreen } from "./FacturacionMaquinaria/FacturacionMaquinariaScreen";
import { DetalleFacturacionAcumuladoScreen } from "../Dashboard/Vendedor/DashScorecardDetalleFacturacionAcumulado";
import { DetalleFacturacionMensualScreen } from "../Dashboard/Vendedor/DashScorecardDetalleFacturacionMensual";
import { ListadoSolicitudesCerradasScreen } from "./SolicitudesCerradas/ListadoSolicitudesCerradasScreen";
import { SolicitudesCerradasDetalleScreen } from "./SolicitudesCerradas/SolicitudesCerradasDetalleScreen";
import { LineasListadoScreen } from "./Lineas/LineasListadoScreen";
import { ModelosListadoScreen } from "./Modelos/ModelosListadoScreen";
import { CotizacionesListadoScreen } from "./Cotizaciones/CotizacionesListadoScreen";
import { AgregarCotizacionScreen } from "./Cotizaciones/AgregarCotizacionScreen";
import { EditarCotizacionScreen } from "./Cotizaciones/EditarCotizacionScreen";
import { ScorecardGrupo } from "./FiltradoScorecardObjetivo/ScorecardGrupo";
import { PromocionesListadoScreen } from "./Promociones/PromocionesListadoScreen";
import { PromocionesModelosListadoScreen } from "./PromocionesModelo/PromocionesModelosListadoScreen";
import { AgregarModelosScreen } from "./Promociones/AgregarModelosScreen";
import { CreditosFacturasPendientesScreen } from "./CreditosFacturasPendientes/CreditosFacturasPendientesScreen";
import { FacturarEquipoScreen } from "./CreditosFacturasPendientes/FacturarEquipoScreen";
import { PrecioLineaMainScreen } from "./PrecioLineas/PrecioLineaMainScreen";
import { PaqueteServicioMainScreen } from "./PaqueteServicio/PaqueteServicioMainScreen";
import { DashScorecardVendedorDetalle } from "../Dashboard/Vendedor/DashScorecardVendedorDetalle";
import { RegistrarCotizacionesScreen } from "./Cotizaciones/RegistrarCotizacionesScreen";
import { CategoriasModelosScreen } from "./CategoriasModelos/CategoriasModelosScreen";
import { EmbudoVentasScreen } from "./EmbudoVentas/EmbudoVentasScreen";
import { EstimacionVentasScreen } from "./EstimacionVentas/EstimacionVentasScreen";
import { ReferenciaBancariaMainScreen } from "../CreditoyCobranza/ReferenciaBancaria/ReferenciaBancariaMainScreen";

export const VentasContext = createContext(null);
export const VentasMain = () => {
  const [stateAnalisis, setStateAnalisis] = useState({
    folio: "",
    cliente: "",
    filtros: {
      razonSocial: [],
      tipoSolicitud: [],
      lineaCredito: [],
      estado: [],
      sucursal: [],
      vendedor: [],
      folio: [],
    },
  });
  const contextValue = useMemo(
    () => ({
      state: stateAnalisis,
      setState: setStateAnalisis,
    }),
    [stateAnalisis, setStateAnalisis]
  );
  return (
    <div className="main-container">
      <VentasContext.Provider value={contextValue}>
        <Route
          path="/Ventas/Main"
          component={() => <ListadoScreenVentas />}
        />
        <Route
          path="/Ventas/LineasScorecard"
          component={() => <LineasScorecardScreen />}
        />
        <Route
          path="/Ventas/ScorecardVendedor"
          component={() => <ScorecardVendedor />}
        />
        <Route
          path="/Ventas/ScorecardObjetivoVendedores"
          component={() => <ListadoVendedores />}
        />
        <Route
          path="/Ventas/ScorecardRealVendedor"
          component={() => <ScorecardRealVendedor />}
        />
        <Route
          path="/Ventas/FiltroScorecardObjetivo"
          component={() => <FiltroScorecard />}
        />
        <Route
          path="/Ventas/ScorecardSucursal"
          component={() => <ScorecardSucursal />}
        />
        <Route
          path="/Ventas/ScorecardGrupo"
          component={() => <ScorecardGrupo />}
        />
        <Route
          path="/Ventas/ScorecardObjetivoVendedor"
          component={() => <ScorecardObjetivoVendedor />}
        />
        <Route
          path="/Ventas/SolicitudesCreditoFacturadas"
          component={() => <SolicitudCreditoFacturada />}
        />
        <Route
          path="/Ventas/TiemposOperacion"
          component={() => <TiemposOperacionScreen />}
        />
        <Route
          path="/Ventas/DashboardScorecardVendedor"
          component={() => <DashScorecardVendedorScreen />}
        />
        <Route
          path="/Ventas/DashboardScorecardGerente"
          component={() => <DashScorecardGerenteScreen />}
        />
        <Route
          path="/Ventas/DetalleFacturacionMensual"
          component={() => <DetalleFacturacionMensualScreen />}
        />
        <Route
          path="/Ventas/DetalleFacturacionAcumulado"
          component={() => <DetalleFacturacionAcumuladoScreen />}
        />
        <Route
          path="/Ventas/FacturacionMaquinaria"
          component={() => <FacturacionMaquinariaScreen />}
        />
        <Route
          path="/Ventas/SolicitudesCerradas"
          component={() => <ListadoSolicitudesCerradasScreen />}
        />
        <Route
          path="/Ventas/SolicitudesCerradasTimeline"
          component={() => <SolicitudesCerradasDetalleScreen />}
        />
        <Route
          path="/Ventas/Lineas"
          component={() => <LineasListadoScreen />}
        />
        <Route
          path="/Ventas/Modelos"
          component={() => <ModelosListadoScreen />}
        />
        <Route
          path="/Ventas/Cotizaciones"
          component={() => <CotizacionesListadoScreen />}
        />
        <Route
          path="/Ventas/RealizarCotizacion"
          component={() => <AgregarCotizacionScreen />}
        />
        <Route
          path="/Ventas/RegistrarCotizacion"
          component={() => <RegistrarCotizacionesScreen />}
        />
        <Route
          path="/Ventas/EditarCotizacion"
          component={() => <EditarCotizacionScreen />}
        />
        <Route
          path="/Ventas/Promociones"
          component={() => <PromocionesListadoScreen />}
        />
        <Route
          path="/Ventas/AgregarModeloEsquema"
          component={() => <AgregarModelosScreen />}
        />
        <Route
          path="/Ventas/PromocionesModelo"
          component={() => <PromocionesModelosListadoScreen />}
        />
        <Route
          path="/Ventas/FacturasPendientes"
          component={() => <CreditosFacturasPendientesScreen />}
        />
        <Route
          path="/Ventas/PrecioLineas"
          component={() => <PrecioLineaMainScreen />}
        />
        <Route
          path="/Ventas/FacturasEquipo"
          component={() => <FacturarEquipoScreen />}
        />
        <Route
          path="/Ventas/PaqueteServicio"
          component={() => <PaqueteServicioMainScreen />}
        />
        <Route
          path="/Ventas/DashboardScorecardVendedorDetalle"
          component={() => <DashScorecardVendedorDetalle />}
        />
        <Route
          path="/Ventas/CategoriasModelos"
          component={() => <CategoriasModelosScreen />}
        />
        <Route
          path="/Ventas/EmbudoVentas"
          component={() => <EmbudoVentasScreen />}
        />
        <Route
          path="/Ventas/EstimacionVentas"
          component={() => <EstimacionVentasScreen />}
        />
        <Route
          path="/Ventas/ReferenciasBancarias"
          component={() => <ReferenciaBancariaMainScreen />}
        />
      </VentasContext.Provider>
    </div>
  );
};
